async function renderTradeInDetails() {
  const urlParams = new URLSearchParams(window.location.search);
  const tradeinUuid = urlParams.get('tradeinuuid');
  const tradeInData = await getTradein(tradeinUuid);
  redirectIfNeeded(tradeInData)
  renderTradeInStatus(tradeInData);
  renderTradeInCreditDetails(tradeInData);
  displayTradeinValue(tradeInData);
}

function redirectIfNeeded(tradeInData) {
  if (!tradeInData && !Shopify.designMode) {
    window.location.href = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-cart`);
    return;
  }

  if (tradeInData.tradeinType !== 'insti' && !Shopify.designMode) {
    window.location = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-status?tradeinuuid=${tradeInData.uuid}`);
  }
}

function displayTradeinValue (tradeInData) {
  const creditValueEl = document.querySelector('.credit-value');
  const giftcardValueEl = document.querySelector('.giftcard-value');

  creditValueEl.textContent = formatMoney(tradeInData.tradeinValueLow);

  const giftcardsSum = tradeInData.giftcards.reduce((sum, { amount }) => sum + amount, 0);
  giftcardValueEl.textContent = formatMoney(giftcardsSum);
}

function renderTradeInCreditDetails(tradeInData) {
  const giftcards = tradeInData.giftcards;
  if (!giftcards || !showCreditDetails) return;
  const creditDetailsWrapper = document.querySelector('.trade-in-status-instore__credit-details');
  creditDetailsWrapper.classList.remove('hidden');
  giftcards.forEach((giftcard) => {
    const tradeInCreditDetailsEl = document.createElement('div');
    tradeInCreditDetailsEl.classList.add('trade-in-credit-details');

    const tradeInCreditDetailsInnerDiv = document.createElement('div');
    tradeInCreditDetailsEl.appendChild(tradeInCreditDetailsInnerDiv);

    const giftCardLastFour = document.createElement('div');
    giftCardLastFour.classList.add('trade-in-credit-details__gift-card-number', 'p-regular', 'p-bold');
    giftCardLastFour.textContent = `${TRADE_IN_STATUS_INSTORE_CONFIG.lastFourLabel}${giftcard.lastFour}`;

    const issuedOn = document.createElement('div');
    issuedOn.classList.add('trade-in-credit-details__issued-on');
    issuedOn.textContent = `${TRADE_IN_STATUS_INSTORE_CONFIG.issuedOnLabel}${DATE_TIME_FORMATS.PADDED_NUMERIC_DATE.format(new Date(giftcard.createdAtIso))}`;

    const startingBalance = document.createElement('div');
    startingBalance.classList.add('trade-in-credit-details__starting-balance', 'p-regular', 'p-bold');
    startingBalance.innerHTML = `${TRADE_IN_STATUS_INSTORE_CONFIG.startingBalanceLabel}<span class='p-regular'>${formatMoney(giftcard.amount)}</span>`;

    const remainingBalance = document.createElement('div');
    remainingBalance.classList.add('trade-in-credit-details__remaining-balance', 'p-regular', 'p-bold');
    remainingBalance.innerHTML = `${TRADE_IN_STATUS_INSTORE_CONFIG.remainingBalanceLabel}<span class='p-regular'>${
      giftcard.differentFromCurrentVendor ?
        'N/A' :
        formatMoney(giftcard.balanceAmount)
    }</span>`;

    tradeInCreditDetailsInnerDiv.appendChild(giftCardLastFour);
    tradeInCreditDetailsInnerDiv.appendChild(issuedOn);
    tradeInCreditDetailsInnerDiv.appendChild(startingBalance);
    tradeInCreditDetailsInnerDiv.appendChild(remainingBalance);

    const resendGiftcardExpirationDate = new Date();
    resendGiftcardExpirationDate.setDate(resendGiftcardExpirationDate.getDate() - numberOfDaysToDisplayResendLink)

    const compareDates = (date1, date2) => date1.getTime() < date2.getTime();

    if (compareDates(resendGiftcardExpirationDate, new Date(giftcard.createdAtIso)) || numberOfDaysToDisplayResendLink < 0) {
      const resendGiftCardEl = document.createElement('div');
      resendGiftCardEl.classList.add('trade-in-credit-details__resend-giftcard');
      resendGiftCardEl.textContent = TRADE_IN_STATUS_INSTORE_CONFIG.resendGiftcardLabel;
      resendGiftCardEl.addEventListener('click', () => resendGiftCardEmail(giftcard.uuid, giftcard.lastFour, giftcard.email));
      tradeInCreditDetailsEl.appendChild(resendGiftCardEl);
    }

    creditDetailsWrapper.appendChild(tradeInCreditDetailsEl);
  })
}

async function renderTradeInStatus(tradeInData) {
  const { uuid, tradeinItems, initiatedAt } = tradeInData;
  const tradeInNumberText = document.createTextNode(`TN-${getUuidPrefix(uuid).toUpperCase()}`);
  document.querySelector('.trade-in-number').appendChild(tradeInNumberText);

  const initiatedAtDate = DATE_TIME_FORMATS.PADDED_NUMERIC_DATE.format(new Date(initiatedAt));
  const tradeInInitiatedDate = document.createTextNode(initiatedAtDate);
  document.querySelector('.trade-in-initiated-date').appendChild(tradeInInitiatedDate);

  const tradeInItemList = document.querySelector('trade-in-item-list');
  tradeInItemList.renderTradeInItems(tradeinItems);

  renderTracker(tradeInData);
}

async function renderTracker(tradeIn) {
  const state = tradeIn.state;
  const stepper = document.querySelector('.trade-in-status-instore__tracker-list');
  const list = stepper.childNodes;
  const statesMap = {
    "INSTI_CREATED": 1,
    "INSTI_INITIATED": 1,
    "INSTI_NOTIFY": 1,
    "INSTI_READY": 1,
    "INSTI_PROCESSING": 1,
    "INSTI_NOT_COMPLETED": 1,
    "CANCELED_IN_STORE": 3,
    "CANCELED": 3,
    "INSTI_COMPLETED": 5,
  };
  if (!statesMap[state]) return;
  for (let x = 0; x <= statesMap[state]; x++) {
    if (list[x].nodeName === 'LI') {
      list[x].classList.add('completed-step');
    }
  }
  if (['CANCELED_IN_STORE', 'CANCELED'].includes(state)) {
    const tradeinCanceledTracker = document.querySelector('.trade-in-status-instore__tracker-step.tradein-canceled');
    const tradeinCompletedTracker = document.querySelector('.trade-in-status-instore__tracker-step.tradein-complete');
    const trackerFooterCanceledMessage = document.querySelector('.trade-in-status-instore__tracker-footer-canceled-message')
    tradeinCanceledTracker.classList.remove('hidden');
    trackerFooterCanceledMessage.classList.remove('hidden');
    tradeinCompletedTracker.classList.add('hidden');
    return;
  }
  if (state !== 'INSTI_COMPLETED') {
    const trackerFooterMessage = document.querySelector('.trade-in-status-instore__tracker-footer-message');
    trackerFooterMessage.classList.remove('hidden');
  }
}

renderTradeInDetails();

function getUuidPrefix(uuid) {
  let uuidPrefix = ""
  for(let character of uuid) {
    if (character === "-") break;
    uuidPrefix += character
  }
  return uuidPrefix;
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelector('.trade-in-status-instore__breadcrumb')
    .classList[
      ORDER_TRADE_IN_LOOKUP_TOKEN_UTILS.getActiveToken() ? 'remove' : 'add'
    ]('hidden');
});
